var _path, _path2, _line, _line2, _line3, _line4, _line5, _line6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubscription(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "news",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.225,
    height: 22.149,
    viewBox: "0 0 21.225 22.149",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_25697",
    "data-name": "Path 25697",
    d: "M19.235,0H4.643a2.034,2.034,0,0,0-1.99,2.076V3.461H1.99A2.034,2.034,0,0,0,0,5.537V19.38a2.713,2.713,0,0,0,2.653,2.769H18.572a2.713,2.713,0,0,0,2.653-2.769V2.076A2.034,2.034,0,0,0,19.235,0ZM19.9,19.38a1.359,1.359,0,0,1-1.327,1.384H2.653A1.358,1.358,0,0,1,1.327,19.38V5.537a.678.678,0,0,1,.663-.692h.663V18.688a.664.664,0,1,0,1.327,0V2.076a.678.678,0,0,1,.663-.692H19.235a.679.679,0,0,1,.663.692Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_25709",
    "data-name": "Path 25709",
    d: "M99.438,58.979H109.5a1.3,1.3,0,0,0,1.438-1.1V50.153a1.3,1.3,0,0,0-1.438-1.1H99.438A1.3,1.3,0,0,0,98,50.153v7.722A1.3,1.3,0,0,0,99.438,58.979Z",
    transform: "translate(-92.367 -46.278)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_576",
    "data-name": "Line 576",
    x2: 6.215,
    transform: "translate(6.531 15.875)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_579",
    "data-name": "Line 579",
    x2: 6.215,
    transform: "translate(6.531 17.172)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_581",
    "data-name": "Line 581",
    x2: 6.215,
    transform: "translate(6.531 18.469)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_577",
    "data-name": "Line 577",
    x2: 6.215,
    transform: "translate(11.458 15.875)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Line_578",
    "data-name": "Line 578",
    x2: 6.215,
    transform: "translate(11.458 17.172)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "Line_580",
    "data-name": "Line 580",
    x2: 6.215,
    transform: "translate(11.458 18.469)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.7c377af1f27383baaad2ce9751c94544.svg";
export { ForwardRef as ReactComponent };